export const scrollToBottom = (selector: string) => {
	const el = document.querySelector(selector);
	if (el) {
		el.scrollTop = el.scrollHeight - el.clientHeight;
	}
};
